import classNames from 'classnames';
import React from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import css from './SocialWebButton.module.scss';

const SocialWebButton = ({ onClick, type }) => {
    return (
        <div
            onClick={onClick}
            className={
                type === 'next'
                    ? classNames(css.buttonArrow, css.buttonArrowNext)
                    : classNames(css.buttonArrow, css.buttonArrowPrev)
            }
        >
            <div style={{ display: 'flex' }}>
                {svgSprite(type === 'next' ? 'angle-right' : 'angle-left', {
                    width: '8px',
                    height: '14px',
                    fill: 'var(--greySuperDarkColor)'
                })}
            </div>
        </div>
    );
};
export default SocialWebButton;
